import type { ValidationResult } from 'joi';
import { cloneDeep } from 'lodash';

import { DBDocObject } from '../../../generic/db-doc/db-doc-object';
import { DBDocSchema } from '../../../generic/db-doc/db-doc-schema';

import { UserPresenceConnectionConstructor } from './user-presence-connection-constructor';
import { UserPresenceConnectionDeviceType } from './user-presence-connection-device-type';
import { UserPresenceConnectionSchema } from './user-presence-connection-schema';

export class UserPresenceConnection extends DBDocObject {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected deviceType!: UserPresenceConnectionDeviceType;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: UserPresenceConnectionConstructor) {
    super(parameters);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): DBDocSchema {
    return new UserPresenceConnectionSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(validationResult: ValidationResult): UserPresenceConnection {
    return new UserPresenceConnection(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(UserPresenceConnection.getSchema(), 'rtdb');
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getDeviceType() {
    return cloneDeep(this.deviceType);
  }
}
